import { useSelector } from 'react-redux';
import { RootState } from 'storage/store';
import { UserDeprecated } from 'storage/user/user.model';

export const useUser = (): UserDeprecated => {
  const user = useSelector((state: RootState) => state.user);

  return user;
};

export default useUser;
